import { logError } from '@marketplace-web/shared/logging'

const CLOSET_ITEM_PREFIX = 'closet_item'

export const logClosetItemError = (error: Error | null) => {
  if (!(error instanceof Error)) return

  logError(error, { feature: CLOSET_ITEM_PREFIX })
}
